export default __webpack_public_path__ + "static/triumph-c4b187f4aa927c699ae0c12423bb0e9d.png";